<div class="container-fluid py-3">
  
  @if(
    streetBuildingService.loading &&
    streetBuildingService.streetsBuildings.length == 0
  ) {

    <div class="col-12 text-center">
      <div class="spinner-border text-primary" role="status">
        <span class="visually-hidden">Loading...</span>
      </div>
    </div>

  } @else {

    <div class="row">

      <!-- Botones de acción -->
      <div class="col-12 mb-3">
        <div class="bg-white rounded-3 shadow-sm p-3">
          <div class="d-flex flex-wrap gap-2">

            <button
              (click)="downloadReport()"
              class="btn btn-primary btn-sm d-flex align-items-center gap-1"
              type="button">
              <i class="material-icons" style="font-size: 1rem;">download</i> Descargar reporte
            </button>

            @if(authService.currentUser?.profile == 'sudo') {

              <button
                (click)="uploadExcel($event)"
                class="btn btn-outline-secondary btn-sm d-flex align-items-center gap-1"
                type="button">
                <i class="material-icons" style="font-size: 1rem;">upload_file</i> Importar casas
              </button>

              <button
                class="btn btn-outline-secondary btn-sm d-flex align-items-center gap-1"
                type="button">
                <i class="material-icons" style="font-size: 1rem;">upload_file</i> Importar calles y casas
              </button>

              <button
                (click)="generateCodes()"
                class="btn btn-outline-success btn-sm d-flex align-items-center gap-1"
                type="button">
                <i class="material-icons" style="font-size: 1rem;">refresh</i> Generar códigos
              </button>

              <button
                (click)="generateUsers()"
                class="btn btn-outline-success btn-sm d-flex align-items-center gap-1"
                type="button">
                <i class="material-icons" style="font-size: 1rem;">refresh</i> Generar usuarios
              </button>

            }

          </div>
        </div>
      </div>

      <!-- Stats cards -->
      <div class="col-12 mb-4">
        <div class="row">

          <!-- No. Casas -->
          <div class="col-6 col-md-4 col-xl mb-3">
            <div class="bg-white rounded-3 shadow-sm p-3 h-100">
              <div class="d-flex justify-content-between align-items-center mb-3">
                <span class="text-secondary fw-500" style="font-size: calc(0.65rem + 0.55vh);">No. Casas</span>
                <div class="rounded-circle d-flex align-items-center justify-content-center"
                  style="height: 2.2rem; width: 2.2rem; background-color: rgba(13,110,253,0.1); flex-shrink: 0;">
                  <i class="material-icons text-primary" style="font-size: 1rem;">home</i>
                </div>
              </div>
              <div class="fw-bold" style="font-size: calc(1rem + 0.8vh);">
                {{ getTotalHousesFlats() }}
              </div>
            </div>
          </div>

          <!-- Activos -->
          <div class="col-6 col-md-4 col-xl mb-3">
            <div class="bg-white rounded-3 shadow-sm p-3 h-100">
              <div class="d-flex justify-content-between align-items-center mb-3">
                <span class="text-secondary fw-500" style="font-size: calc(0.65rem + 0.55vh);">Activos</span>
                <div class="rounded-circle d-flex align-items-center justify-content-center"
                  style="height: 2.2rem; width: 2.2rem; background-color: rgba(25,135,84,0.1); flex-shrink: 0;">
                  <i class="material-icons text-success" style="font-size: 1rem;">check_circle</i>
                </div>
              </div>
              <div class="text-success fw-bold" style="font-size: calc(1rem + 0.8vh);">
                {{ getTotalActiveHousesFlats() }}
              </div>
            </div>
          </div>

          <!-- Inactivos -->
          <div class="col-6 col-md-4 col-xl mb-3">
            <div class="bg-white rounded-3 shadow-sm p-3 h-100">
              <div class="d-flex justify-content-between align-items-center mb-3">
                <span class="text-secondary fw-500" style="font-size: calc(0.65rem + 0.55vh);">Inactivos</span>
                <div class="rounded-circle d-flex align-items-center justify-content-center"
                  style="height: 2.2rem; width: 2.2rem; background-color: rgba(220,53,69,0.1); flex-shrink: 0;">
                  <i class="material-icons text-danger" style="font-size: 1rem;">cancel</i>
                </div>
              </div>
              <div class="text-danger fw-bold" style="font-size: calc(1rem + 0.8vh);">
                {{ getTotalInactiveHousesFlats() }}
              </div>
            </div>
          </div>

          @if(authService.currentUser?.profile == 'sudo') {

            <!-- Dispositivos Activos -->
            <div class="col-6 col-md-4 col-xl mb-3">
              <div class="bg-white rounded-3 shadow-sm p-3 h-100">
                <div class="d-flex justify-content-between align-items-center mb-3">
                  <span class="text-secondary fw-500" style="font-size: calc(0.65rem + 0.55vh);">Dispositivos</span>
                  <div class="rounded-circle d-flex align-items-center justify-content-center"
                    style="height: 2.2rem; width: 2.2rem; background-color: rgba(13,202,240,0.1); flex-shrink: 0;">
                    <i class="material-icons text-info" style="font-size: 1rem;">phone_iphone</i>
                  </div>
                </div>
                <div class="fw-bold" style="font-size: calc(1rem + 0.8vh);">
                  {{ getTotalDevicesActive() }}
                </div>
              </div>
            </div>

            <!-- Dispositivos Inactivos -->
            <div class="col-6 col-md-4 col-xl mb-3">
              <div class="bg-white rounded-3 shadow-sm p-3 h-100">
                <div class="d-flex justify-content-between align-items-center mb-3">
                  <span class="text-secondary fw-500" style="font-size: calc(0.65rem + 0.55vh);">Disp. Inactivos</span>
                  <div class="rounded-circle d-flex align-items-center justify-content-center"
                    style="height: 2.2rem; width: 2.2rem; background-color: rgba(255,193,7,0.1); flex-shrink: 0;">
                    <i class="material-icons text-warning" style="font-size: 1rem;">phone_iphone</i>
                  </div>
                </div>
                <div class="text-warning fw-bold" style="font-size: calc(1rem + 0.8vh);">
                  {{ getTotalDevicesInactive() }}
                </div>
              </div>
            </div>

          }

        </div>
      </div>

      @for (streetBuilding of streetBuildingService.streetsBuildings; track $index) {

        <app-street-building-item
          [streetBuilding]="streetBuilding">
        </app-street-building-item>

      }

    </div>

  }

</div>

<button
  (click)="open()"
  class="btn btn-sm btn-success rounded-circle me-2 my-1 position-fixed"
  style="bottom: 2rem; right: 2rem;">
  <i class="material-icons mt-1">add</i>
</button>
